import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Usuario } from './models/usuario.model';


@Injectable({
  providedIn: 'root'
})
// validación y autenticación de rutas
// https://www.techiediaries.com/angular/angular-9-reactive-forms-validation-tutorial-example/

export class AuthGuard implements CanActivate {

  private OAUTH_URL_GMAUTH = environment.OAUTH_URL_GMAUTH;
  private SERVER_URL = environment.SERVER_USU_URL;
  private CLIENT_ID = environment.CLIENT_ID;
  private CLIENT_SECRET = environment.CLIENT_SECRET;
  private VER_HOME = environment.VER_HOME;
  private LOGIN_IS_HOME = environment.LOGIN_IS_HOME;
  public usuario: Usuario | undefined;
  public usuarios: Usuario[] = [];

  constructor(
    private http: HttpClient,
    private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    /* if (!this.isLoggedIn() && this.LOGIN_IS_HOME) {
      // no se quiere visualizar tienda antes de logear, sino logeado siempre login
      this.router.navigate(['login']);
    } */
    if (state.url === '/' && this.LOGIN_IS_HOME) {
      // no se quiere home
      this.router.navigate(['login']);
    } else if (state.url === '/' && !this.VER_HOME) {
      // no se quiere home
      this.router.navigate(['tienda']);
    }
    return true;
    // return this.isLoggedIn();
  }

  public isLoggedIn() {
    if (typeof localStorage === 'undefined') {
      return false; // Evita el error en SSR
    }

    const usuario: Usuario = localStorage.getItem('usuario_model')
      ? JSON.parse(localStorage.getItem('usuario_model')!)
      : null;
    const token = localStorage.getItem('ACCESS_TOKEN');

    if (token !== null && usuario && usuario.cli_id !== null) {
      return environment.AUTH_TOKEN ? this.checkToken() : true;
    }
    return false;
  }

  public checkToken(): boolean {
    if (localStorage.getItem('ACCESS_TOKEN') == null) {
      return false;
    }
    const fechaToken = localStorage.getItem('ACCESS_TOKEN_DATE') != null ? new Date(parseInt(localStorage.getItem('ACCESS_TOKEN_DATE')!, 10)) : null;
    const fechaAhora = new Date();
    const expireTime = localStorage.getItem('REFRESH_TOKEN_EXPIRE') != null ? parseInt(localStorage.getItem('REFRESH_TOKEN_EXPIRE')!, 10) : null;
    if (fechaToken != null && expireTime != null) {
      fechaToken.setTime(fechaToken.getTime() + expireTime * 1000);
    }

    if (fechaToken != null && fechaToken.getTime() < fechaAhora.getTime()) {
      // console.log(fechaToken.toISOString() +  ' CADUCADO');
      return false;
    } else {
      // console.log(fechaToken.toISOString() +  ' DISPONIBLE');
      return true;
    }
    // llamada a null con el token para detectar 401.
    const token = localStorage.getItem('ACCESS_TOKEN');
    this.http.get<Usuario>(environment.SERVER_ADM_URL + '/test', {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token
      })
    }).subscribe(

    );
  }

  getAccessToken(): Promise<any> {
    if (this.checkToken()) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(localStorage.getItem('ACCESS_TOKEN'));
        }, 1);
      });
    } else {
      return this.renovarTokenPhp();
    }
  }

  private renovarTokenPhp(): Promise<any> {
    // 'https://asg-gemmasales.asg-si.net/slim-gsa-api/index-password.php/token'; <-- TEST
    const url = this.OAUTH_URL_GMAUTH + '/token';

    return this.http.post(url, '')
      .toPromise()
      .then((response: any) => {
        localStorage.setItem('ACCESS_TOKEN', response.access_token);
        localStorage.setItem('ACCESS_TOKEN_EXPIRE', response.expires_in);
        localStorage.setItem('ACCESS_TOKEN_TYPE', response.token_type);
        localStorage.setItem('ACCESS_TOKEN_DATE', Date.now().toString());

        return localStorage.getItem('ACCESS_TOKEN');
      });
  }

  public logToken() {
    const url = this.SERVER_URL + '/token';
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      });
    const usuario: Usuario = localStorage.getItem('usuario_model') != null ? JSON.parse(localStorage.getItem('usuario_model')!) : null;
    const options = { headers };
    // tslint:disable-next-line:prefer-const
    const log: Log = {
      usuw_id: usuario.usuw_id,
      token: localStorage.getItem('ACCESS_TOKEN') ? localStorage.getItem('ACCESS_TOKEN')! : '',
      caducidad: localStorage.getItem('ACCESS_TOKEN_EXPIRE')
    };
    // this.http.post(url, log, options)
    //     .toPromise()
    //     .then((response: any) => {
    //       console.log(response);
    //     });
    this.http.post(url,
      log, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
        // Authorization: this.SERVER_AUTH
      })
    }).toPromise()
      .then((response: any) => {
        console.log(response);
      });
  }

}

interface Log {
  usuw_id: number;
  token: string;
  caducidad: string | null;
}
